import { render, staticRenderFns } from "./FatorRisco.vue?vue&type=template&id=4c233bbe"
import script from "./FatorRisco.vue?vue&type=script&lang=js"
export * from "./FatorRisco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports